import { render, staticRenderFns } from "./VillageMange.vue?vue&type=template&id=2556a62a"
import script from "./VillageMange.vue?vue&type=script&lang=js"
export * from "./VillageMange.vue?vue&type=script&lang=js"
import style0 from "./VillageMange.vue?vue&type=style&index=0&id=2556a62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports